var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19319",
    "data-name": "Group 19319",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.397,
    height: 13.834,
    viewBox: "0 0 18.397 13.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19444",
    "data-name": "Group 19444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19445",
    "data-name": "Group 19445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247892",
    "data-name": "Path 247892",
    d: "M232.133,262.5a2.133,2.133,0,1,0,2.133,2.133,2.135,2.135,0,0,0-2.133-2.133m0,3.2a1.067,1.067,0,1,1,1.067-1.067,1.068,1.068,0,0,1-1.067,1.067",
    transform: "translate(-226.02 -260.033)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247893",
    "data-name": "Path 247893",
    d: "M160.281,607.65a.535.535,0,0,0-.6-.068,3.256,3.256,0,0,1-2.971,0,.535.535,0,0,0-.6.068A3.2,3.2,0,0,0,155,610.081v.533a.533.533,0,0,0,.533.533h5.333a.533.533,0,0,0,.533-.533v-.533a3.2,3.2,0,0,0-1.119-2.431m-4.214,2.431a2.136,2.136,0,0,1,.512-1.386,4.329,4.329,0,0,0,3.242,0,2.136,2.136,0,0,1,.512,1.386Z",
    transform: "translate(-152.051 -600.469)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247895",
    "data-name": "Path 247895",
    d: "M12,13.373a.5.5,0,0,0-.531-.461H2.133a1,1,0,0,1-1.067-.922V1.845A1,1,0,0,1,2.133.922h9.4A.467.467,0,0,0,12,.432.422.422,0,0,0,11.531,0h-9.4A2.007,2.007,0,0,0,0,1.845V11.989a2.007,2.007,0,0,0,2.133,1.845h9.335A.5.5,0,0,0,12,13.373",
    fill: "#c3c3c3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19459",
    "data-name": "Group 19459",
    transform: "translate(12.016 3.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247928",
    "data-name": "Path 247928",
    d: "M705.845,338.152a.319.319,0,0,1,.319.319v.319h2.553v-.319a.319.319,0,1,1,.638,0v.319h.319a.957.957,0,0,1,.957.957v2.233a.319.319,0,0,1-.638,0V340.7h-5.105v2.872a.319.319,0,0,0,.319.319h1.6a.319.319,0,1,1,0,.638h-1.6a.957.957,0,0,1-.957-.957v-3.829a.957.957,0,0,1,.957-.957h.319v-.319a.319.319,0,0,1,.319-.319m-.638,1.276a.319.319,0,0,0-.319.319v.319h5.105v-.319a.319.319,0,0,0-.319-.319Z",
    transform: "translate(-704.25 -338.152)",
    fill: "#c3c3c3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247930",
    "data-name": "Path 247930",
    d: "M.051.057A.388.388,0,0,0,.1.5l.7,1-.315.315a.243.243,0,0,0,.344.344l.487-.487a.243.243,0,0,0,0-.344L.445.089A.31.31,0,0,0,.051.057Z",
    transform: "matrix(0.391, 0.921, -0.921, 0.391, 5.033, 4.236)",
    fill: "#c3c3c3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingStatus);
export default __webpack_public_path__ + "static/media/bookingStatus.45168ac05914ce7f1bfb323c337ce838.svg";
export { ForwardRef as ReactComponent };